/**
 * BS4 → BS5 Compatibility Shim
 *
 * Copies BS4 data attributes to their BS5 equivalents so that Blade templates
 * using old data-toggle="dropdown" etc. keep working with Bootstrap 5's JS.
 *
 * IMPORTANT: Only copies for standard Bootstrap component values.
 * Dashmix custom values (layout, block-option, submenu, theme, class-toggle)
 * are left untouched — Dashmix template.js handles those directly.
 *
 * Remove this shim after all templates have been migrated to data-bs-* attributes.
 */
document.addEventListener('DOMContentLoaded', () => {
    const bsToggleValues = ['tooltip', 'popover', 'dropdown', 'modal', 'collapse', 'tab', 'pill', 'button'];

    // data-toggle → data-bs-toggle (selective)
    document.querySelectorAll('[data-toggle]').forEach(el => {
        const value = el.getAttribute('data-toggle');
        if (bsToggleValues.includes(value) && !el.hasAttribute('data-bs-toggle')) {
            el.setAttribute('data-bs-toggle', value);
        }
    });

    // data-dismiss → data-bs-dismiss
    document.querySelectorAll('[data-dismiss]').forEach(el => {
        if (!el.hasAttribute('data-bs-dismiss')) {
            el.setAttribute('data-bs-dismiss', el.getAttribute('data-dismiss'));
        }
    });

    // data-target → data-bs-target
    document.querySelectorAll('[data-target]').forEach(el => {
        if (!el.hasAttribute('data-bs-target')) {
            el.setAttribute('data-bs-target', el.getAttribute('data-target'));
        }
    });

    // data-toggle="tabs" (Dashmix 4 pattern: parent <ul> has the attribute, not individual links)
    // BS5 needs data-bs-toggle="tab" on each individual <a> nav-link
    document.querySelectorAll('[data-toggle="tabs"]').forEach(ul => {
        ul.querySelectorAll('.nav-link').forEach(link => {
            if (!link.hasAttribute('data-bs-toggle')) {
                link.setAttribute('data-bs-toggle', 'tab');
            }
        });
    });

    // data-content → data-bs-content (popovers)
    document.querySelectorAll('[data-content]').forEach(el => {
        if (!el.hasAttribute('data-bs-content')) {
            el.setAttribute('data-bs-content', el.getAttribute('data-content'));
        }
    });

    // data-placement → data-bs-placement (tooltips/popovers)
    document.querySelectorAll('[data-placement]').forEach(el => {
        if (!el.hasAttribute('data-bs-placement')) {
            el.setAttribute('data-bs-placement', el.getAttribute('data-placement'));
        }
    });

    // data-parent → data-bs-parent (accordions/collapse)
    document.querySelectorAll('[data-parent]').forEach(el => {
        if (!el.hasAttribute('data-bs-parent')) {
            el.setAttribute('data-bs-parent', el.getAttribute('data-parent'));
        }
    });

    // MutationObserver for dynamic content (DataTables, AJAX responses, etc.)
    // Watches for new elements with BS4 data-toggle and converts them to BS5
    const observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (node.nodeType !== 1) continue; // skip text nodes

                // Process the added node itself and its descendants
                const elements = node.matches?.('[data-toggle]') ? [node] : [];
                if (node.querySelectorAll) {
                    elements.push(...node.querySelectorAll('[data-toggle]'));
                }

                for (const el of elements) {
                    const value = el.getAttribute('data-toggle');
                    if (bsToggleValues.includes(value) && !el.hasAttribute('data-bs-toggle')) {
                        el.setAttribute('data-bs-toggle', value);
                    }
                }

                // Also convert data-dismiss, data-target, data-placement on dynamic content
                if (node.querySelectorAll) {
                    node.querySelectorAll('[data-dismiss]:not([data-bs-dismiss])').forEach(el => {
                        el.setAttribute('data-bs-dismiss', el.getAttribute('data-dismiss'));
                    });
                    node.querySelectorAll('[data-target]:not([data-bs-target])').forEach(el => {
                        el.setAttribute('data-bs-target', el.getAttribute('data-target'));
                    });
                    node.querySelectorAll('[data-placement]:not([data-bs-placement])').forEach(el => {
                        el.setAttribute('data-bs-placement', el.getAttribute('data-placement'));
                    });
                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

// NOTE: jQuery method bridges ($.fn.popover with getTipElement, etc.)
// are in bs4-jquery-bridges.js — imported AFTER Bootstrap 5 loads in app.js
// so our bridges can override BS5's own jQuery plugins.
